const {constructTheme} = require('./theme');

// primary and alteredPrimaryColor are the same as defined in main-fo.scss
export const theme = constructTheme('#3B2D6D', '#6C3A94', {
  MuiInputBase: {
    root: {
      fontSize: '1.4rem'
    }
  },
  MuiOutlinedInput: {
    root: {
      '&:hover $notchedOutline': {
        borderColor: '#3B2D6D' // purple-brand
      }
    },
    input: {
      padding: '15.5px 14px'
    }
  },
  MuiInputLabel: {
    root: {
      fontSize: '1.4rem'
    },
    outlined: {
      transform: 'translate(14px, 17px) scale(1)',
      color: '#3B2D6D', // purple-brand
      '&$shrink': {
        color: '#3B2D6D' // purple-brand
      }
    }
  },
  MuiMenuItem: {
    root: {
      fontSize: '1.4rem'
    }
  },
  MuiTypography: {
    body1: {
      fontSize: '1.4rem'
    }
  },
  MuiFab: {
    root: {
      position: 'fixed',
      bottom: 30,
      right: 30,
      zIndex: 13,
      fontFamily: 'Inter'
    },
    colorInherit: {
      backgroundColor: '#3B2D6D', // purple-brand
      color: '#fff',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#6C3A94' // purple-brand-hover
      }
    }
  },
  MuiFormLabel: {
    root: {
      color: '#3B2D6D' // purple-brand
    }
  }
});
